import React from 'react'
import PropTypes from 'prop-types'
import { CaptionText, LoadingSpinner } from '@paypalcorp/pp-react'
import { Message } from '@paypalcorp/worldready-react'
import { css } from '@emotion/core'
import { screenSmall } from './screen-sizes'
import { isMobileNative } from 'utils/mobile'

const fullPageSpinnerCss = css`
  position: fixed;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  top: 0;
  left: 0;
  z-index: 1100;
  height: 100%;
  background: rgba(255, 255, 255, 0.7);

  // Modal styling, max width to overlay only the content width
  max-width: 44.875rem;
  right: 0;
  margin-left: auto;
  margin-right: auto;
`

const fullPageSpinnerNativeCss = css`
  position: fixed;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  top: 0;
  left: 0;
  z-index: 1100;
  height: 100%;
  width: 100%;
  max-width: none;
  background: #ffffff;
`

const loadingSpinnerCss = css`
  margin-bottom: 1rem;

  @media (max-width: ${screenSmall}) {
    width: 3rem !important;
    height: 3rem !important;
  }
`

export default function FullPageSpinner({ mainPage, noBackground, oldFlowModal }) {
  // Native WKWebView: solid backdrop + no animated xl spinner (WebKit.GPU crash risk).
  if (isMobileNative()) {
    return (
      <div
        css={fullPageSpinnerNativeCss}
        data-testid="page-spinner"
        data-native-safe-loading="true"
      >
        <CaptionText>
          <Message id="common.justAFewMoments" />
        </CaptionText>
      </div>
    )
  }

  let spinnerDivCss = css`
    ${fullPageSpinnerCss};
  `

  if (oldFlowModal) {
    spinnerDivCss = css`
      ${spinnerDivCss};
      max-width: none;
    `
  }

  if (mainPage) {
    spinnerDivCss = css`
      ${spinnerDivCss};
      position: fixed;
      width: 100%;
      max-width: none;
    `
  }

  // Used in ModalShell for main page
  if (noBackground) {
    spinnerDivCss = css`
      ${spinnerDivCss};
      background: none;
      z-index: unset;
    `
  }

  return (
    <div css={spinnerDivCss}>
      <LoadingSpinner
        size="xl"
        screenReaderText={<Message id="common.loading" />}
        css={loadingSpinnerCss}
        data-testid="page-spinner"
      />
      <CaptionText>
        <Message id="common.justAFewMoments" />
      </CaptionText>
    </div>
  )
}

FullPageSpinner.propTypes = {
  mainPage: PropTypes.bool,
  noBackground: PropTypes.bool,
  oldFlowModal: PropTypes.bool,
}
